// HALAMAN YANG MEMUAT DETAIL FAKTUR PEMBATALAN PENJUALAN
import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, Modal } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Axios from 'axios';
import {
  CRUDLayout,
  Input,
  DataStatus,
  Alert,
  THead,
  TBody,
  ThFixed,
  TdFixed,
  Tr,
  Td,
  Th,
  BackButton,
  DeleteButton,
  UpdateButton,
  ActionButton,
  SelectSearch,
  TextArea,
  UpdateModal,
} from '../../../../components';
import { RupiahConvert, DateConvert } from '../../../../utilities';
import { TipeBarangJadiApi } from '../../../../api';
const TambahTipeBarangJadi = ({ setNavbarTitle }) => {
  // USE HISTORY
  const history = useHistory();

  // STATE LOADING
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdateForm, setIsUpdateForm] = useState(false); // MODAL UPDATE STATE
  const [updateData, setUpdateData] = useState([]);

  // STATE MENAMPUNG DATA
  const [data, setData] = useState({});

  const [listTipeBarangJadi, setListTipeBarangJadi] = useState([]);
  const [listFactorySupply, setListFactorySupply] = useState([]);
  const [listLabourCost, setListLabourCost] = useState([]);
  const [listMachineProcess, setListMachineProcess] = useState([]);
  const [listOverheadPabrik, setListOverheadPabrik] = useState([]);

  const [dropdownFS, setDropdownFS] = useState([]);
  const [dropdownLC, setDropdownLC] = useState([]);
  const [dropdownMP, setDropdownMP] = useState([]);
  const [dropdownBOP, setDropdownBOP] = useState([]);

  const [grandTotal, setGrandTotal] = useState(0);

  // ALERT STATE
  const [showAlert, setShowAlert] = useState(false);

  // KONFIGURASI ALERT
  const [alertConfig, setAlertConfig] = useState({
    variant: 'primary',
    text: '',
  });

  // FUNCTION GET DATA DARI SERVER
  const getData = () => {
    setIsLoading(true);
    Axios.all([
      TipeBarangJadiApi.getDropdownKelompokTipeBarangJadi(),
      TipeBarangJadiApi.getDropdownItem('fs'),
      TipeBarangJadiApi.getDropdownItem('lc'),
      TipeBarangJadiApi.getDropdownItem('mp'),
      TipeBarangJadiApi.getDropdownItem('bop'),
    ])
      .then(
        Axios.spread((kelompok_dropdown, fs, lc, mp, bop) => {
          setListTipeBarangJadi(kelompok_dropdown.data.data);
          setDropdownFS(fs.data.data);
          setDropdownLC(lc.data.data);
          setDropdownMP(mp.data.data);
          setDropdownBOP(bop.data.data);
        })
      )
      .catch((err) => alert(err.response.data.message))
      .finally(() => setIsLoading(false));
  };

  // ON COMPONENT MOUNT
  useEffect(() => {
    setIsLoading(true);
    setNavbarTitle('Tambah Data Tipe Barang Jadi'); // SET JUDUL NAVBAR
    getData(); // GET DATA DARI SERVER
  }, []);

  // TABLE COMPONENT
  const Table = (props) => {
    const toCommas = (val) => {
      return val.toString().replace(/\./g, ',');
    };

    const handleRemoveItem = (itemIndex) => {
      let temp = [];
      switch (props.kode) {
        case 'fs':
          temp = [...listFactorySupply];
          temp = temp.filter((item, index) => index != itemIndex);
          setListFactorySupply([...temp]);
          break;
        case 'lc':
          temp = [...listLabourCost];
          temp = temp.filter((item, index) => index != itemIndex);
          setListLabourCost([...temp]);
          break;
        case 'mp':
          temp = [...listMachineProcess];
          temp = temp.filter((item, index) => index != itemIndex);
          setListLabourCost([...temp]);
          break;
        default:
          temp = [...listOverheadPabrik];
          temp = temp.filter((item, index) => index != itemIndex);
          setListLabourCost([...temp]);
          break;
      }
    };
    return (
      <CRUDLayout.Table>
        <THead>
          <Tr className="text-center">
            <ThFixed>No</ThFixed>
            <ThFixed>Kode Item</ThFixed>
            <Th>Nama Item</Th>
            <ThFixed>Qty</ThFixed>
            <ThFixed>Unit </ThFixed>
            <Th>Unit Price</Th>
            <ThFixed>Konstanta</ThFixed>
            <Th>Jumlah</Th>
            <ThFixed>Aksi</ThFixed>
          </Tr>
        </THead>
        <TBody>
          {props.data.length > 0 ? (
            props.data?.map((val, index) => {
              // TAMBAH KEY sub_total PADA ELEMENT BARANG
              // val.sub_total = parseInt(val.harga_satuan * val.qty);
              return (
                <Tr key={props.kode + index}>
                  <TdFixed>{index + 1}</TdFixed>
                  <TdFixed>{val.kode_item_bahan}</TdFixed>
                  <Td>{val.label}</Td>
                  <Td textRight>{toCommas(val.qty)}</Td>
                  <Td>{val.nama_satuan}</Td>
                  <Td width={150} textRight>
                    {RupiahConvert(String(parseInt(val.harga_satuan))).detail}
                  </Td>
                  <TdFixed>{toCommas(val.koefisien)}</TdFixed>
                  <Td width={150} textRight>
                    {RupiahConvert(String(val.sub_total)).detail}
                  </Td>
                  <TdFixed>
                    <div className="d-flex justify-content-center">
                      {/* <UpdateButton
                          onClick={() => {
                            setIsUpdateForm(true)
                            setUpdateData({ itemIndex: index, kode: props.kode, ...val })
                          }} /> */}
                      <DeleteButton onClick={() => handleRemoveItem(index)} />
                    </div>
                  </TdFixed>
                </Tr>
              );
            })
          ) : (
            <Tr>
              <Td colSpan="9">
                <DataStatus text="Tidak ada data" />
              </Td>
            </Tr>
          )}
          {props.data.length > 0 ? (
            <Tr>
              <Td textRight colSpan="7">
                <strong>Total {props.title}</strong>
              </Td>
              <Td textRight>
                <strong>
                  {
                    RupiahConvert(
                      String(
                        props.data.reduce(
                          (sum, { sub_total }) => sum + parseInt(sub_total),
                          0
                        )
                      )
                    ).detail
                  }
                </strong>
              </Td>
              <Td></Td>
            </Tr>
          ) : (
            <div />
          )}
        </TBody>
      </CRUDLayout.Table>
    );
  };

  const PilihItem = (props) => {
    const [item, setItem] = useState({});
    const [qty, setQty] = useState(1);
    const [koefisien, setKoefisien] = useState('1');
    const [satuan, setSatuan] = useState('');
    const [hargaSatuan, setHargaSatuan] = useState('0');
    const [subTotal, setSubTotal] = useState('0');

    const [dropdownData, setDropdownData] = useState([]);

    const getDataDropdown = () => {
      switch (props.kode) {
        case 'fs':
          setDropdownData([...dropdownFS]);
          break;
        case 'lc':
          setDropdownData([...dropdownLC]);
          break;
        case 'mp':
          setDropdownData([...dropdownMP]);
          break;
        default:
          setDropdownData([...dropdownBOP]);
          break;
      }
    };

    const handleSubmit = () => {
      // CHECK IF item & qty ISN'T EMPTY
      if (!(Object.entries(item).length === 0) && qty != 0) {
        // let sub_total = qty * hargaSatuan * koefisien;
        const finalValues = { ...item, qty, koefisien, sub_total: subTotal };
        switch (props.kode) {
          case 'fs':
            setListFactorySupply((prevState) => [...prevState, finalValues]);
            break;
          case 'lc':
            setListLabourCost((prevState) => [...prevState, finalValues]);
            break;
          case 'mp':
            setListMachineProcess((prevState) => [...prevState, finalValues]);
            break;
          default:
            setListOverheadPabrik((prevState) => [...prevState, finalValues]);
            break;
        }
        setSubTotal(0);
        setQty(0);
        setKoefisien(1);
        setHargaSatuan(0);
      } else {
      }
    };

    useEffect(() => {
      let sub_total = parseFloat(qty) * hargaSatuan * parseFloat(koefisien);
      setSubTotal(Math.round(sub_total));
    }, [qty, hargaSatuan, koefisien]);

    return (
      <form onSubmit={handleSubmit}>
        <div className="d-flex flex-row justify-content-between align-items-end mb-1">
          <div style={{ minWidth: '250px' }}>
            <SelectSearch
              label={`Pilih Item ${props.title}`}
              name="item"
              placeholder="Pilih Item"
              onChange={(val) => {
                setItem(val);
                setSatuan(val.nama_satuan);
                setHargaSatuan(val.harga_satuan ?? 0);
              }}
              onFocus={getDataDropdown}
              option={dropdownData.map((val) => {
                return {
                  value: val.id_item_buaso,
                  label: val.nama_item,
                  tipe: props.kode,
                  id_item_buaso: val.id_item_buaso,
                  nama_satuan: val.nama_satuan,
                  harga_satuan: val.harga_satuan ?? 0,
                  kode_item_bahan: val.kode_item_bahan,
                };
              })} //option harus berupa value dan label
              defaultValue=""
            />
          </div>

          <Input
            style={{ maxWidth: '80px' }}
            label="Qty"
            type="number"
            name="qty"
            value={qty}
            onChange={(val) => setQty(val.target.value)}
            min={1}
            step={0.1}
            placeholder="Qty"
          />

          <Input
            style={{ maxWidth: '100px' }}
            label="Unit"
            type="text"
            name="satuan"
            value={satuan}
            placeholder="Unit"
            readOnly={true}
          />

          <Input
            style={{ maxWidth: '150px' }}
            label="Unit Price"
            type="text"
            value={RupiahConvert(String(parseInt(hargaSatuan))).detail}
            name="harga_satuan"
            placeholder="Unit Price"
            readOnly={true}
          />

          <Input
            style={{ maxWidth: '80px' }}
            label="Konstanta"
            type="number"
            name="koefisien"
            value={koefisien}
            onChange={(val) => setKoefisien(val.target.value)}
            min={1}
            step={0.1}
            placeholder="Koefisien"
          />

          <Input
            style={{ maxWidth: '150px' }}
            label="Sub Total Price"
            type="text"
            value={RupiahConvert(String(subTotal)).detail}
            name="sub_total"
            placeholder="Sub Total Price"
            readOnly={true}
          />

          <ActionButton
            size="sm"
            style={{ marginBottom: '0.5rem' }}
            onClick={handleSubmit}
            variant="primary"
            text="Tambah Ke List"
            className="text-white"
          />
        </div>
      </form>
    );
  };

  // MODAL UBAH COMPONENT
  const EditItemModal = () => {
    const [dropdownData, setDropdownData] = useState([]);

    const getDataDropdown = () => {
      switch (updateData.tipe) {
        case 'fs':
          setDropdownData([...dropdownFS]);
          break;
        case 'lc':
          setDropdownData([...dropdownLC]);
          break;
        case 'mp':
          setDropdownData([...dropdownMP]);
          break;
        default:
          setDropdownData([...dropdownBOP]);
          break;
      }
    };

    const formInitialValues = {
      id_item_buaso: updateData.id_item_buaso,
      label: updateData.label,
      nama_satuan: updateData.nama_satuan,
      harga_satuan: updateData.harga_satuan,
      qty: updateData.qty,
      tipe: updateData.tipe,
      kode_item_bahan: '',
    };

    // KIRIM UPDATE DATA KE SERVER
    const formSubmitHandler = (values) => {
      let temp = [];

      const finalValues = {
        value: values.id_item_buaso,
        ...values,
      };

      // UPDATED LIST
      switch (updateData.tipe) {
        case 'fs':
          temp = [...listFactorySupply];
          temp = temp.filter((item, index) => index != updateData.itemIndex);
          setListFactorySupply([...temp, finalValues]);
          break;
        case 'lc':
          temp = [...listLabourCost];
          temp = temp.filter((item, index) => index != updateData.itemIndex);
          setListLabourCost([...temp, finalValues]);
          break;
        case 'mp':
          temp = [...listMachineProcess];
          temp = temp.filter((item, index) => index != updateData.itemIndex);
          setListLabourCost([...temp, finalValues]);
          break;
        default:
          temp = [...listOverheadPabrik];
          temp = temp.filter((item, index) => index != updateData.itemIndex);
          setListLabourCost([...temp, finalValues]);
          break;
      }
      setIsUpdateForm(false);
    };

    return (
      <UpdateModal
        show={isUpdateForm}
        onHide={() => setIsUpdateForm(false)}
        title={`Item ${
          updateData.kode == 'fs'
            ? 'Factory Supply'
            : updateData.kode == 'lc'
            ? 'Labour Cost'
            : updateData.kode == 'mp'
            ? 'Machine Process'
            : 'Biaya Overhead'
        }`}
      >
        <Formik initialValues={formInitialValues} onSubmit={formSubmitHandler}>
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Body>
                <SelectSearch
                  label="Nama Item"
                  name="id_item_buaso"
                  placeholder="Pilih Nama Item"
                  onFocus={getDataDropdown}
                  onChange={(val) => {
                    setFieldValue('id_item_buaso', val.value);
                    setFieldValue('kode_item_bahan', val.kode_item_bahan);
                    setFieldValue('label', val.label);
                    setFieldValue('nama_satuan', val.nama_satuan);
                    setFieldValue('harga_satuan', val.harga_satuan);
                  }}
                  option={dropdownData.map((val) => {
                    return {
                      value: val.id_item_buaso,
                      label: val.nama_item,
                      id_item_buaso: val.id_item_buaso,
                      nama_satuan: val.nama_satuan,
                      harga_satuan: val.harga_satuan ?? 5000,
                      kode_item_bahan: val.kode_item_bahan,
                    };
                  })} //option harus berupa value dan label
                  defaultValue={{
                    label: updateData.label,
                    value: values.id_item_buaso,
                  }}
                  error={errors.id_item_buaso && touched.id_item_buaso && true}
                  errorText={
                    errors.id_item_buaso &&
                    touched.id_item_buaso &&
                    errors.id_item_buaso
                  }
                />

                <Input
                  label="Satuan"
                  type="text"
                  name="nama_satuan"
                  value={values.nama_satuan}
                  placeholder="Satuan"
                  readOnly={true}
                />

                <Input
                  label="Harga Satuan"
                  type="text"
                  name="harga_satuan"
                  value={values.harga_satuan}
                  placeholder="Harga Satuan"
                  readOnly={true}
                />

                <Input
                  label="Qty"
                  type="number"
                  name="qty"
                  value={values.qty}
                  onChange={handleChange}
                  min={1}
                  placeholder="Qty"
                />
              </Modal.Body>

              <Modal.Footer>
                <ActionButton
                  type="submit"
                  variant="success"
                  text="Ubah"
                  loading={isSubmitting}
                />
              </Modal.Footer>
            </form>
          )}
        </Formik>
      </UpdateModal>
    );
  };

  // INITIAL VALUES FORM TAMBAH DATA TIPE BARANG JADI
  const formInitialValues = {
    id_kelompok_tipe_barang_jadi: '',
    nama_tipe_barang_jadi: '',
    deskripsi: '',
  };

  // FORMIK VALIDATION SCHEMA TIPE BARANG JADI DENGAN YUP VALIDATION
  const formValidationSchema = Yup.object().shape({
    id_kelompok_tipe_barang_jadi: Yup.string().required(
      'Pilih Kelompok Tipe Barang'
    ),
    nama_tipe_barang_jadi: Yup.string().required(
      'Masukkan Nama Tipe Barang Jadi'
    ),
  });

  // KIRIM UPDATE DATA KE SERVER
  const formSubmitHandler = (values) => {
    // SEND UPDATED DATA TO SERVER
    const finalValues = {
      ...values,
      detail: [
        ...listFactorySupply,
        ...listLabourCost,
        ...listMachineProcess,
        ...listOverheadPabrik,
      ],
    };

    TipeBarangJadiApi.create(finalValues)
      .then((res) => {
        history.push('/master/tipe-barang-jadi', {
          registerAlertConfig: {
            variant: 'primary',
            text: 'Tambah data berhasil!',
          },
        });
      })
      .catch((err) => {
        // ERROR ALERT
        setAlertConfig({
          variant: 'danger',
          text: `Tambah data gagal! (${err.response.data.message})`,
        });
      })
      .finally(() => {
        // SHOW ALERT
        setShowAlert(true);
      });
  };

  const hitungGrandTotal = () => {
    let totalFS =
      listFactorySupply.length > 0
        ? listFactorySupply.reduce(
            (sum, obj) => sum + parseInt(obj?.sub_total ?? 0),
            0
          )
        : 0;
    let totalMP =
      listMachineProcess.length > 0
        ? listMachineProcess.reduce(
            (sum, obj) => sum + parseInt(obj?.sub_total ?? 0),
            0
          )
        : 0;
    let totalLC =
      listLabourCost.length > 0
        ? listLabourCost.reduce(
            (sum, obj) => sum + parseInt(obj?.sub_total ?? 0),
            0
          )
        : 0;
    let totalBOP =
      listOverheadPabrik.length > 0
        ? listOverheadPabrik.reduce(
            (sum, obj) => sum + parseInt(obj?.sub_total ?? 0),
            0
          )
        : 0;

    let grand =
      parseInt(totalFS) +
      parseInt(totalLC) +
      parseInt(totalMP) +
      parseInt(totalBOP);
    setGrandTotal(grand);
  };

  useEffect(() => {
    hitungGrandTotal();
  }, [
    listFactorySupply,
    listLabourCost,
    listMachineProcess,
    listOverheadPabrik,
  ]);

  return (
    <CRUDLayout>
      {/* Alert */}
      <Alert
        show={showAlert}
        showCloseButton={true}
        variant={alertConfig.variant}
        text={alertConfig.text}
        onClose={() => setShowAlert(false)}
      />

      <Card className="pb-3 mt-3">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <b>Tambah Data Sub Tipe Produksi</b>
          <BackButton size="sm" onClick={() => history.goBack()} />
        </Card.Header>
        {isLoading ? (
          <DataStatus loading={isLoading} text="Memuat Data" />
        ) : (
          <Card.Body>
            <Formik
              initialValues={formInitialValues}
              validationSchema={formValidationSchema}
              onSubmit={formSubmitHandler}
            >
              {({
                values,
                errors,
                touched,
                isSubmitting,
                handleChange,
                handleSubmit,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="container my-2 px-2">
                    <div className="row">
                      <div className="col">
                        <SelectSearch
                          label="Tipe produksi"
                          name="id_kelompok_tipe_barang_jadi"
                          placeholder="Pilih tipe produksi"
                          onChange={(val) =>
                            setFieldValue(
                              'id_kelompok_tipe_barang_jadi',
                              val.value
                            )
                          }
                          option={listTipeBarangJadi.map((val) => {
                            return {
                              value: val.id_kelompok_tipe_barang_jadi,
                              label: val.nama_kelompok_barang_jadi,
                            };
                          })} //option harus berupa value dan label
                          defaultValue=""
                          error={
                            errors.id_kelompok_tipe_barang_jadi &&
                            touched.id_kelompok_tipe_barang_jadi &&
                            true
                          }
                          errorText={
                            errors.id_kelompok_tipe_barang_jadi &&
                            touched.id_kelompok_tipe_barang_jadi &&
                            errors.id_kelompok_tipe_barang_jadi
                          }
                        />

                        <Input
                          label="Nama sub tipe produksi"
                          type="text"
                          name="nama_tipe_barang_jadi"
                          placeholder="Nama Tipe Barang Jadi"
                          value={values.nama_tipe_barang_jadi}
                          onChange={handleChange}
                          error={
                            errors.nama_tipe_barang_jadi &&
                            touched.nama_tipe_barang_jadi &&
                            true
                          }
                          errorText={errors.nama_tipe_barang_jadi}
                        />
                      </div>

                      <div className="col">
                        {/* DESKRIPSI */}
                        <TextArea
                          label="Deskripsi"
                          placeholder="Deskripsi"
                          onChange={handleChange}
                          name="deskripsi"
                          rows={4}
                        />
                      </div>
                    </div>

                    <hr />
                    {!isLoading && (
                      <PilihItem
                        title="Factory Supply"
                        kode="fs"
                        dropdownData={dropdownFS}
                      />
                    )}
                    <div style={{ fontSize: 14 }} className="mb-1 mt-3">
                      <strong>List Item Factory Supply</strong>
                    </div>
                    <Table
                      data={listFactorySupply}
                      title="Factory Supply"
                      kode="fs"
                    />

                    <hr />
                    {!isLoading && (
                      <PilihItem
                        title="Labour Cost"
                        kode="lc"
                        dropdownData={dropdownLC}
                      />
                    )}
                    <div style={{ fontSize: 14 }} className="mb-1 mt-3">
                      <strong>List Item Labour Cost MGP</strong>
                    </div>
                    <Table
                      data={listLabourCost}
                      title="Labour Cost MGP"
                      kode="lc"
                    />

                    <hr />
                    {!isLoading && (
                      <PilihItem
                        title="Machine Process"
                        kode="mp"
                        dropdownData={dropdownMP}
                      />
                    )}
                    <div style={{ fontSize: 14 }} className="mb-1 mt-3">
                      <strong>List Item Machine Process</strong>
                    </div>
                    <Table
                      data={listMachineProcess}
                      title="Machine Process"
                      kode="mp"
                    />

                    <hr />
                    {!isLoading && (
                      <PilihItem
                        title="Biaya Overhead"
                        kode="bop"
                        dropdownData={dropdownBOP}
                      />
                    )}
                    <div style={{ fontSize: 14 }} className="mb-1 mt-3">
                      <strong>List Item Biaya Overhead</strong>
                    </div>
                    <Table
                      data={listOverheadPabrik}
                      title="Biaya Overhead"
                      kode="bop"
                    />

                    <CRUDLayout.Table classname="mx-3">
                      <THead>
                        <Tr className="text-center">
                          <Th>
                            <div className="text-right">Grand Total</div>
                          </Th>
                          <Th style={{ width: '10%' }}>
                            <div className="text-right">
                              {RupiahConvert(String(grandTotal)).detail}
                            </div>
                          </Th>
                        </Tr>
                      </THead>
                    </CRUDLayout.Table>

                    <div className="d-flex justify-content-end mt-2">
                      <ActionButton
                        type="submit"
                        className="btn btn-primary text-white"
                        size="md"
                        text="Simpan"
                      />
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </Card.Body>
        )}
      </Card>
      {isUpdateForm && <EditItemModal />}
    </CRUDLayout>
  );
};
export default TambahTipeBarangJadi;
